import { useMutation } from "@tanstack/react-query";
import { updateWeeklySchedule } from "../../queries/ScheduleHub";

interface IUpdateHubWeekScheduleParams {
  idCronograma: string;
  fromDate: Date;
  toDate: Date;
  discipline: string;
  oldDate?: Date;
}

export const useUpdateHubWeekSchedule = () => {
  const { data, isPending, isError, mutate } = useMutation({
    mutationKey: ['updateHubWeekSchedule'],
    mutationFn: (params: IUpdateHubWeekScheduleParams) => updateWeeklySchedule(params.idCronograma, params.fromDate, params.toDate, params.discipline, params.oldDate),
    retry: false,
  });

  return { mutate, isPending, isError, data };
};